export interface IGeocodePoint {
  lat: string
  lon: string
  osm_type?: string
  boundingbox: string[]
  geojson: { type: string; coordinates: any }
  [key: string]: any
}

export const buildGeocodeUrl = (baseUrl: string, query: string): string =>
  `${baseUrl}/api/v1/map_data?q=${encodeURIComponent(
    query
  )}&polygon_geojson=1&format=json&limit=10&countrycodes=us,ca`

export const selectGeocodePoint = (
  pointData: IGeocodePoint[]
): IGeocodePoint | null => {
  if (!Array.isArray(pointData)) {
    return null
  }

  const withinBounds = pointData.filter(
    ({ lat, lon, boundingbox: [sL, nL, wL, eL] }) => {
      const latitude = parseFloat(lat)
      const longitude = parseFloat(lon)

      return (
        parseFloat(sL) <= latitude &&
        latitude <= parseFloat(nL) &&
        parseFloat(wL) <= longitude &&
        parseFloat(eL) >= longitude
      )
    }
  )

  const relations = withinBounds.filter((e) => e.osm_type === 'relation')
  const candidates = relations.length > 0 ? relations : withinBounds

  return candidates.length > 0 ? candidates[0] : null
}
